<template>
    <!-- <div class="pay" v-loading="loading">
    </div> -->
    <div v-html ='apply' v-show="loading"></div>

</template>
 
<script>
// import {recharge} from '@/api/cost'
	
export default {
    data(){
        return {
            apply:'',
 			loading: false
         }
    },
	created(){
		// let obj = {
		// 	inputNum:this.$route.query.count,
		// 	returnUrl:''
		// }
	    // recharge(obj).then(response => {
    	// 	if(response.data.status != 200){
    	// 		return this.tipWarning(response.data.msg)
    	// 	}
    	// 	this.loading = false;
    	// 	this.payUrl = response.data.data.url;
        //     document.write(this.payUrl)
		// }).catch((error) => {
		//     console.log(error);
		//     this.loading = false;
		// });
	},
   	mounted(){
		//    this.apply=this.$route.query.htmlData
			var url = localStorage.getItem('fromUrl');
			this.apply = url;
			localStorage.removeItem('fromUrl');
		   setTimeout(() =>{
			   this.loading = true;
		   },1200)
            this.$nextTick(()=> {
                document.getElementById('alipaysubmit').submit()
            })

    },
    methods:{
    },
}
</script>
 
<style scoped>
.pay{
	width: 100%;
	height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Scan.vue